import moment from 'moment'
import * as participantStatuses from '@/components/common/data/participant-statuses'

export const LOGS_ACTION_TYPES = {
  DELETED: 'Deleted',
  EDITED: 'Edited',
  CREATED: 'Created'
}

export const FILE_FIELDS = {
  DE_REPORTS: 'Site readiness act',
  DE_DOCS: 'ME report',
  DE_DOCS_NOC: 'NOK Protocol'
}

export const FILE_CATEGORY = {
  [FILE_FIELDS.DE_REPORTS]: 'reports',
  [FILE_FIELDS.DE_DOCS]: 'docs',
  [FILE_FIELDS.DE_DOCS_NOC]: 'docs-noc'
}

export const LOGS_ACTION_CATEGORIES = {
  EXPERTS: 'Experts',
  DOCUMENTS: 'Documents',
  DE: 'DE',
  EXAM_GROUPS: 'Exam groups'
}

export const LOG_VALUES = {
  REQUESTED: 'requested',
  ACCEPTED: 'accepted',
  DECLINED: 'declined',
  NONE: 'none',
  NEW: 'new',
  REVIEW_AUTH_ORG: 'review_auth_org',
  REVISION_AUTH_ORG: 'revision_auth_org',
  REVIEW_DE_DEPARTMENT: 'review_de_department',
  REVISION_DE_DEPARTMENT: 'revision_de_department',
  AGREED_DE_DEPARTMENT: 'agreed_de_department',
  CONFIRMED_AUTH_ORG: 'confirmed_auth_org',
  CONFIRMED_AUTH_ORG_BLOCKED: 'confirmed_auth_org_blocked',
  APPROVED_MAIN_EXPERT: 'approved_main_expert',
  APPROVED_MAIN_EXPERT_BLOCKED: 'approved_main_expert_blocked',
  COMPLETE_MAIN_EXPERT: 'complete_main_expert',
  COMPLETE_MAIN_EXPERT_BLOCKED: 'complete_main_expert_blocked',
  REGISTERED: 'registered',
  APPROVED: 'approved',
  PASSED: 'passed',
  REMOTE_EXPERTS: 'remote_experts',
  REMOTE_MEMBERS: 'remote_members',
  STATE_STANDARD: 'state_standard',
  SECONDARY_DEGREE: 'secondary_degree',
  STATE_FINAL_ATTESTATION: 'state_final_attestation',
  COMMERCIAL_EXAM: 'commercial_exam',
  REGIONAL_EXAM: 'regional_exam',
  ADDITIONAL_EDUCATION: 'additional_education',
  OTHER_EXAM: 'other_exam',
  OTHER: 'other',
  CORPORATE: 'corporate',
  VOLUNTARY_QUALIFY_EXAM: 'voluntary_qualify_exam',
  MASTER_OF_INDUSTRIAL_EDU: 'master_of_industrial_edu',
  FIFTY: '50_plus',
  INDEPENDENT_ESTIMATE: 'independent_estimate',
  NOT_STATE_STANDARD: 'not_state_standard',
  PROFESSIONAL_EDUCATION: 'professional_education',
  WISE: 'wise',
  REGIONS: 'regions',
  ADDITIONAL_EDUCATION_JUNIOR_ADULT: 'additional_education_junior_adult',
  ADDITIONAL_EDUCATION_JUNIOR_ADULT_COMMON: 'additional_education_junior_adult_common',
  ADDITIONAL_EDUCATION_JUNIOR_ADULT_PROFESSIONAL: 'additional_education_junior_adult_professional',
  ADDITIONAL_PROFESSIONAL_EDUCATION: 'additional_professional_education',
  RETRAINING_WISE: 'retraining_wise',
  DE_LEVEL_INTERMEDIATE_CERTIFICATION: 'de_level_intermediate_certification',
  DE_LEVEL_INTERMEDIATE: 'intermediate',
  UNIVERSITY: 'university',
  DE_LEVEL_BASIC: 'de_level_basic',
  TRAINING: 'training',
  JUNIORS: 'juniors',
  DE_LEVEL_VARIANT: 'de_level_variant',
  UNIVERSITY_DEGREE: 'university_degree',
  TOTAL: 'total',
  DE_LEVEL_PROF_SKILL: 'de_level_prof_skill',
  RETRAINING_REGIONS: 'retraining_regions',
  RETRAINING_OTHERS: 'retraining_others',
  RETRAINING_MASTERS: 'retraining_masters',
  QUALIFICATION_OTHERS: 'qualification_others',
  QUALIFICATION_MASTERS: 'qualification_masters',
  QUALIFICATION_REGIONS: 'qualification_regions',
  QUALIFICATION_WISE: 'qualification_wise'
}

export const LOG_VALUE_SETTINGS = {
  [LOG_VALUES.REQUESTED]: {
    label: 'Запрошен'
  },
  [LOG_VALUES.ACCEPTED]: {
    label: 'Согласован'
  },
  [LOG_VALUES.DECLINED]: {
    label: 'Отклонен'
  },
  [LOG_VALUES.NONE]: {
    label: 'Без указания кандидатуры'
  },
  [LOG_VALUES.NEW]: {
    label: 'Новая заявка'
  },
  [LOG_VALUES.REVIEW_AUTH_ORG]: {
    label: 'Заявка на согласовании в РО'
  },
  [LOG_VALUES.REVISION_AUTH_ORG]: {
    label: 'Заявка отклонена РО'
  },
  [LOG_VALUES.REVIEW_DE_DEPARTMENT]: {
    label: 'Заявка на согласовании у Оператора'
  },
  [LOG_VALUES.REVISION_DE_DEPARTMENT]: {
    label: 'Заявка отклонена Оператором'
  },
  [LOG_VALUES.AGREED_DE_DEPARTMENT]: {
    label: 'Заявка согласована Оператором / Новый экзамен'
  },
  [LOG_VALUES.CONFIRMED_AUTH_ORG]: {
    label: 'Экзамен согласован РО'
  },
  [LOG_VALUES.CONFIRMED_AUTH_ORG_BLOCKED]: {
    label: 'Экзамен согласован РО (заблокирован)'
  },
  [LOG_VALUES.APPROVED_MAIN_EXPERT]: {
    label: 'Экзамен подтвержден ГЭ'
  },
  [LOG_VALUES.APPROVED_MAIN_EXPERT_BLOCKED]: {
    label: 'Экзамен подтвержден ГЭ (заблокирован)'
  },
  [LOG_VALUES.COMPLETE_MAIN_EXPERT]: {
    label: 'Экзамен завершен ГЭ'
  },
  [LOG_VALUES.COMPLETE_MAIN_EXPERT_BLOCKED]: {
    label: 'Экзамен завершен ГЭ (заблокирован)'
  },
  [LOG_VALUES.REGISTERED]: {
    label: 'Добавлен'
  },
  [LOG_VALUES.APPROVED]: {
    label: 'Присутствовал подготовительном дне'
  },
  [LOG_VALUES.PASSED]: {
    label: 'Сдавал'
  },
  [LOG_VALUES.REMOTE_EXPERTS]: {
    label: 'Удаленное присутствие одного или нескольких экспертов (ГЭ или Эксперт)'
  },
  [LOG_VALUES.REMOTE_MEMBERS]: {
    label: 'Удаленное присутствие одного или нескольких участников'
  },
  [LOG_VALUES.STATE_STANDARD]: {
    label: 'ФГОС'
  },
  [LOG_VALUES.SECONDARY_DEGREE]: {
    label: 'Программа СПО'
  },
  [LOG_VALUES.STATE_FINAL_ATTESTATION]: {
    label: 'Выпускник (выпускной курс) - ГИА'
  },
  [LOG_VALUES.COMMERCIAL_EXAM]: {
    label: 'Коммерческий экзамен'
  },
  [LOG_VALUES.REGIONAL_EXAM]: {
    label: 'Региональный экзамен'
  },
  [LOG_VALUES.ADDITIONAL_EDUCATION]: {
    label: 'Дополнительный образование'
  },
  [LOG_VALUES.OTHER_EXAM]: {
    label: 'Другие экзамены'
  },
  [LOG_VALUES.OTHER]: {
    label: 'Другое'
  },
  [LOG_VALUES.CORPORATE]: {
    label: 'Корпоративный экзамен'
  },
  [LOG_VALUES.VOLUNTARY_QUALIFY_EXAM]: {
    label: 'ДКЭ'
  },
  [LOG_VALUES.MASTER_OF_INDUSTRIAL_EDU]: {
    label: 'МПО'
  },
  [LOG_VALUES.FIFTY]: {
    label: '50+'
  },
  [LOG_VALUES.INDEPENDENT_ESTIMATE]: {
    label: 'НОК'
  },
  [LOG_VALUES.NOT_STATE_STANDARD]: {
    label: 'НЕ ФГОС'
  },
  [LOG_VALUES.PROFESSIONAL_EDUCATION]: {
    label: 'Профессиональное обучение'
  },
  [LOG_VALUES.WISE]: {
    label: 'Навыки мудрых'
  },
  [LOG_VALUES.REGIONS]: {
    label: 'Регионы'
  },
  [LOG_VALUES.ADDITIONAL_EDUCATION_JUNIOR_ADULT]: {
    label: 'Дополнительное образование детей и взрослых'
  },
  [LOG_VALUES.ADDITIONAL_EDUCATION_JUNIOR_ADULT_COMMON]: {
    label: 'Общеразвивающие программы (дети и взрослые)'
  },
  [LOG_VALUES.ADDITIONAL_PROFESSIONAL_EDUCATION]: {
    label: 'Дополнительное профессиональное обучение'
  },
  [LOG_VALUES.RETRAINING_WISE]: {
    label: 'Профессиональная переподготовка'
  },
  [LOG_VALUES.DE_LEVEL_INTERMEDIATE_CERTIFICATION]: {
    label: 'ПА'
  },
  [LOG_VALUES.DE_LEVEL_INTERMEDIATE]: {
    label: 'Cтудент'
  },
  [LOG_VALUES.UNIVERSITY]: {
    label: 'ВУЗ'
  },
  [LOG_VALUES.DE_LEVEL_BASIC]: {
    label: 'Базовый уровень'
  },
  [LOG_VALUES.TRAINING]: {
    label: 'Тренировка'
  },
  [LOG_VALUES.JUNIORS]: {
    label: 'Юниоры'
  },
  [LOG_VALUES.DE_LEVEL_VARIANT]: {
    label: 'Профильный уровень (вариативная часть)'
  },
  [LOG_VALUES.UNIVERSITY_DEGREE]: {
    label: 'Программа ВО'
  },
  [LOG_VALUES.TOTAL]: {
    label: 'Выпускник (выпускной курс) - Промежуточная аттестация'
  },
  [LOG_VALUES.DE_LEVEL_PROF_SKILL]: {
    label: 'Профильный уровень'
  },
  [LOG_VALUES.RETRAINING_REGIONS]: {
    label: 'Профессиональная переподготовка - Регионы'
  },
  [LOG_VALUES.RETRAINING_OTHERS]: {
    label: 'Профессиональная переподготовка - Другое'
  },
  [LOG_VALUES.RETRAINING_MASTERS]: {
    label: 'Профессиональная переподготовка - Мастера'
  },
  [LOG_VALUES.RETRAINING_WISE]: {
    label: 'Профессиональная переподготовка - Навыки мудрых'
  },
  [LOG_VALUES.QUALIFICATION_MASTERS]: {
    label: 'Повышение квалификации - Мастера'
  },
  [LOG_VALUES.QUALIFICATION_REGIONS]: {
    label: 'Повышение квалификации - Регионы'
  },
  [LOG_VALUES.QUALIFICATION_WISE]: {
    label: 'Повышение квалификации - Навыки мудрых'
  },
  [LOG_VALUES.QUALIFICATION_OTHERS]: {
    label: 'Повышение квалификации - Другое'
  },
  [LOG_VALUES.ADDITIONAL_EDUCATION_JUNIOR_ADULT_PROFESSIONAL]: {
    label: 'Предпрофессиональные программы (дети)'
  }

}

export const LOG_FIELDS = {
  COMPLEXITY_LEVEL: 'Complexity level',
  DE_CENTER: 'DE Center',
  STREAM_LINK: 'Stream Link',
  TECHNICAL_EXPERT: 'Technical Expert',
  DAY_C1: 'Day C-1',
  LINEAL_EXPERT: 'Lineal Expert',
  SITE_READINESS_ACT: 'Site readiness act',
  COMMENT: 'Comment',
  MAIN_EXPERT: 'Main Expert',
  ME_REPORT: 'ME report',
  STATUS: 'Status',
  LINEAL_EXPERT_STATUS: 'Lineal Expert Status',
  TECHNICAL_EXPERT_STATUS: 'Technical Expert Status',
  DE_NAME: 'DE Name',
  MAIN_EXPERT_STATUS: 'Main Expert Status',
  COMPETENCE: 'Competence',
  NOK_PROTOCOL: 'NOK Protocol',
  PARTICIPANT_STATUS: 'Participant status',
  EXAM_GROUP: 'Exam group',
  ISSUE_TASK: 'Issue task',
  DATE_EXAM_GROUPS_START: 'Date exam groups start',
  DATE_EXAM_GROUPS_FINISH: 'Date exam groups finish',
  ME_REPORT_WITH_MTO: 'ME Report with MTO',
  ME_PASSPORT: 'ME Passport',
  MTO_REPORT: 'MTO Report',
  EXPENDABLE_MATERIALS_REPORT: 'Expendable Materials Report',
  DATE_DEMO_EXAMS_FINISH: 'Date demo exams finish',
  DATE_DEMO_EXAMS_START: 'Date demo exams start',
  EXAM_FLAG: 'Exam Flag'
}

export const LOG_FIELD_SETTINGS = {
  [LOG_FIELDS.COMPLEXITY_LEVEL]: {
    label: 'КОД'
  },
  [LOG_FIELDS.DE_CENTER]: {
    label: 'ЦПДЭ'
  },
  [LOG_FIELDS.STREAM_LINK]: {
    label: 'Ссылка на видеотрансляцию'
  },
  [LOG_FIELDS.TECHNICAL_EXPERT]: {
    label: 'Технический эксперт'
  },
  [LOG_FIELDS.DAY_C1]: {
    label: 'Дата ПД'
  },
  [LOG_FIELDS.LINEAL_EXPERT]: {
    label: 'Эксперт'
  },
  [LOG_FIELDS.SITE_READINESS_ACT]: {
    label: 'Акт готовности площадки'
  },
  [LOG_FIELDS.COMMENT]: {
    label: 'Комментарий к экзамену'
  },
  [LOG_FIELDS.MAIN_EXPERT]: {
    label: 'Главный эксперт'
  },
  [LOG_FIELDS.ME_REPORT]: {
    label: 'Отчет главного эксперта'
  },
  [LOG_FIELDS.STATUS]: {
    label: 'Статус экзамена'
  },
  [LOG_FIELDS.LINEAL_EXPERT_STATUS]: {
    label: 'Статус эксперта'
  },
  [LOG_FIELDS.TECHNICAL_EXPERT_STATUS]: {
    label: 'Статус технического эксперта'
  },
  [LOG_FIELDS.DE_NAME]: {
    label: 'Наименование ДЭ'
  },
  [LOG_FIELDS.MAIN_EXPERT_STATUS]: {
    label: 'Статус главного эксперта'
  },
  [LOG_FIELDS.COMPETENCE]: {
    label: 'Профессия/специальность (ДЭ)'
  },
  [LOG_FIELDS.EXAM_GROUP]: {
    label: 'Экз. группа'
  },
  [LOG_FIELDS.PARTICIPANT_STATUS]: {
    label: 'Статус участника'
  },
  [LOG_FIELDS.ISSUE_TASK]: {
    label: 'Выдача задания'
  },
  [LOG_FIELDS.DATE_EXAM_GROUPS_START]: {
    label: 'Дата начала'
  },
  [LOG_FIELDS.DATE_EXAM_GROUPS_FINISH]: {
    label: 'Дата окончания'
  },
  [LOG_FIELDS.ME_REPORT_WITH_MTO]: {
    label: 'Сведения о материально-техническом обеспечении (МТО)'
  },
  [LOG_FIELDS.ME_PASSPORT]: {
    label: 'Паспорт ЦПДЭ и сведения о материально-техническом обеспечении и расходных материалах'
  },
  [LOG_FIELDS.MTO_REPORT]: {
    label: 'Сведения о материально-техническом обеспечении (МТО)'
  },
  [LOG_FIELDS.EXPENDABLE_MATERIALS_REPORT]: {
    label: 'Расходные материалы'
  },
  [LOG_FIELDS.DATE_DEMO_EXAMS_FINISH]: {
    label: 'Дата окончания демонстрационных экзаменов'
  },
  [LOG_FIELDS.DATE_DEMO_EXAMS_START]: {
    label: 'Дата начала демонстрационных экзаменов'
  },
  [LOG_FIELDS.EXAM_FLAG]: {
    label: 'Тип экзамена'
  }
}

export const LOGS_ACTION_SETTINGS = {
  [LOGS_ACTION_TYPES.DELETED]: {
    label: 'Удалено',
    type: 'danger'
  },
  [LOGS_ACTION_TYPES.EDITED]: {
    label: 'Изменено',
    type: 'warning'
  },
  [LOGS_ACTION_TYPES.CREATED]: {
    label: 'Создано',
    type: 'info'
  }
}

export const LOGS_ACTION_CATEGORIES_LABELS = {
  [LOGS_ACTION_CATEGORIES.DE]: {
    label: 'Экзамен'
  },
  [LOGS_ACTION_CATEGORIES.EXPERTS]: {
    label: 'Эксперты'
  },
  [LOGS_ACTION_CATEGORIES.DOCUMENTS]: {
    label: 'Документы'
  },
  [LOGS_ACTION_CATEGORIES.EXAM_GROUPS]: {
    label: 'Экз. группы'
  }
}

export function getLogActionCategory (category) {
  return LOGS_ACTION_CATEGORIES_LABELS[category] || { label: category }
}

export function isValidGuid (value) {
  const pattern = new RegExp('^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$', 'i')
  return pattern.test(value)
}

export function isExperts (category, value) {
  return LOGS_ACTION_CATEGORIES.EXPERTS === category && isValidGuid(value)
}

export function getLogAction (type) {
  return LOGS_ACTION_SETTINGS[type]
}
export function getLogField (field) {
  return LOG_FIELD_SETTINGS[field] ? LOG_FIELD_SETTINGS[field] : { label: field }
}

export function isDateFormat (field) {
  return field === LOG_FIELDS.DATE_EXAM_GROUPS_START ||
        field === LOG_FIELDS.DATE_EXAM_GROUPS_FINISH ||
        field === LOG_FIELDS.ISSUE_TASK
}

export function getDate (value) {
  return moment(value, 'YYYY-MM-DD HH:mm:ss Z').format('LL')
}

export function getAllParticipants (shifts) {
  const participants = new Set()
  const groups = shifts.flatMap(s => s.groups)
  const groupParticipants = groups.flatMap(g => g && g.participants ? g.participants : [])

  groupParticipants.forEach(p => participants.add(p))

  return [...participants]
}

export function getPassedCount (allParticipants) {
  return allParticipants.reduce((acc, i) => acc + (i.status === participantStatuses.PASSED), 0)
}

export function getResultsImported (allParticipants) {
  const mark100List = allParticipants.filter(i => i.scaled_mark.mark100)
  return mark100List.length
}
